import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, useHistory } from "react-router-dom";

interface IProps {
  component: React.FC<any>;
  path: string;
  exact?: boolean;
  selectorFn: (state: any) => any[];
  redirectTo?: string;
  matchId: string;
  resourceField: string;
  message?: string;
  navigateTo?: string;
  buttonText?: string;
}

// By default, RedirectRoute will route to '/404' if
// no the prop 'redirectTo' is not present
const RedirectRoute: React.FC<IProps> = ({
  component: Component,
  selectorFn,
  redirectTo,
  matchId,
  resourceField,
  navigateTo,
  buttonText,
  message,
  ...rest
}) => {
  const history: any = useHistory();
  const resourceList = useSelector(selectorFn);
  const redirect = !resourceList.find(resource => resource[resourceField] === matchId);
  const token = localStorage.getItem("studioToken");
  const pathname = token ? (redirectTo || '/404') : '/signin';

  useEffect(() => {
    if (redirect) {
      history.push({
        pathname,
        state: {
          navigateTo,
          buttonText,
          message,
        }
      });
    }
  }, [redirect, buttonText, history, message, navigateTo, pathname])

  return (
    <Route
      {...rest}
      render={(props) => {
        return <Component {...props} />;
      }}
    />
  );
};

export default RedirectRoute;
